/**
 * Mobile/tablet: keep cart in the header above the fold;
 * switch to a floating FAB once the user scrolls.
 */
(function () {
  var MQ = '(max-width: 989px)';
  var THRESHOLD = 80;
  var cart = null;
  var media = null;
  var ticking = false;

  function getCart() {
    return document.getElementById('cart-icon-bubble');
  }

  function update() {
    cart = getCart();
    if (!cart || !media) return;

    if (!media.matches) {
      cart.classList.remove('is-fab');
      return;
    }

    var scrolled = window.scrollY > THRESHOLD || document.documentElement.scrollTop > THRESHOLD;
    cart.classList.toggle('is-fab', scrolled);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      update();
    });
  }

  function init() {
    cart = getCart();
    if (!cart) return;

    media = window.matchMedia(MQ);
    update();

    window.addEventListener('scroll', onScroll, { passive: true });
    if (typeof media.addEventListener === 'function') {
      media.addEventListener('change', update);
    } else if (typeof media.addListener === 'function') {
      media.addListener(update);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
